import React from 'react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'

import { styled } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'
import Tooltip from '@mui/material/Tooltip'

import AppPropTypes from '../../shared/appPropTypes'
import { getNameInitials } from '../../helpers/common'

const StyledAvatarBase = styled(Avatar)(({ theme }) => ({
  boxSizing: 'border-box',
  boxShadow: 'none',
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  marginRight: theme.spacing(0.5),
  '&:first-child': {
    marginLeft: 0
  },
  '&:last-child': {
    marginRight: 0
  }
}))

const StyledAvatarOwner = styled(StyledAvatarBase)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  border: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark
  }
}))

const StyledAvatarContributor = styled(StyledAvatarBase)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.secondary.main,
  border: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark
  }
}))

const StyledAvatarReader = styled(StyledAvatarBase)(({ theme }) => ({
  color: theme.palette.text.primary,
  border: `3px solid ${theme.palette.secondary.main}`,
  backgroundColor: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    borderColor: theme.palette.secondary.dark
  }
}))

const StyledAvatarBasic = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white
}))

const sizeStyles = {
  tiny: { width: '32px', height: '32px', fontSize: '0.7rem' },
  small: { width: '32px', height: '32px', fontSize: '0.7rem' },
  medium: { width: '48px', height: '48px', fontSize: '0.875rem' },
  large: { width: '56px', height: '56px', fontSize: '0.875rem' }
}

const UserAvatar = ({ name, role, size = 'small' }) => {
  const sizeStyle = sizeStyles[size] || sizeStyles.small

  const AvatarComponent =
    role === 'Owner'
      ? StyledAvatarOwner
      : role === 'Contributor'
      ? StyledAvatarContributor
      : role === 'Reader'
      ? StyledAvatarReader
      : StyledAvatarBasic

  return (
    <Tooltip title={`${name} ${role ? '(' + capitalize(role) + ')' : ''}`}>
      <AvatarComponent style={sizeStyle}>
        {getNameInitials(name)}
      </AvatarComponent>
    </Tooltip>
  )
}
UserAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  role: AppPropTypes.role,
  size: AppPropTypes.mduiSizes
}

export default UserAvatar
